<template>
    <div class="main-container">
        <Header @showLeftMenuClick="showLeftMenu" :title="title"></Header>
        <div class="left-menu">
            <van-popup v-model="isShowLeftMenu" position="left"
                :style="{ height: '100vh', width: '70vw', backgroundColor: '#f5f5f5' }">
                <van-cell-group inset style="margin-top: 20px;">
                    <van-cell title="首页" is-link @click="() => doRouteLink(0)" />
                </van-cell-group>
                <van-cell-group inset style="margin-top: 20px;">
                    <van-cell title="自律" is-link @click="() => doRouteLink(1)" />
                    <van-cell title="记账" is-link @click="() => doRouteLink(2)" />
                </van-cell-group>
                <van-cell-group inset style="margin-top: 20px;">
                    <van-cell title="日程" is-link @click="() => doRouteLink(3)" />
                    <van-cell title="网盘" is-link @click="() => doRouteLink(4)" />
                </van-cell-group>
                <van-button type="info" style="margin-top:30px;margin-left:30px" @click="handleLogout">退出登录</van-button>
            </van-popup>
        </div>
        <router-view></router-view>
    </div>
</template>

<script>
import Header from './components/Header.vue'

export default {
    components: {
        Header,
    },
    data() {
        return {
            // 头部标题
            title: "",
            // 是否显示左侧菜单
            isShowLeftMenu: false,
        }
    },
    methods: {
        // 退出登录
        handleLogout() {
            let _self = this;
            _self.$router.push("/login");

            let userId = localStorage.getItem("id");
            localStorage.removeItem("id");
            localStorage.removeItem("username");
            localStorage.removeItem("avatar");
            localStorage.removeItem("nickname");
            localStorage.removeItem("token");
            _self.$router.push("/login");
            _self.$api.user
                .logout({ id: Number(userId) })
                .then(res => {
                    console.log(res);
                })
                .catch(err => {
                    console.log(err);
                });
        },
        // 点击左边菜单跳转到对应的页面
        doRouteLink(index) {
            let _self = this;
            switch (index) {
                case 0:
                    _self.$router.push('/home');
                    _self.title = "首页";
                    _self.isShowLeftMenu = false;
                    break;
                case 1:
                    _self.$router.push('/selftrain');
                    _self.title = "自律";
                    _self.isShowLeftMenu = false;
                    break;
                case 2:
                    _self.$router.push('/account');
                    _self.title = "记账";
                    _self.isShowLeftMenu = false;
                    break;
                case 3:
                    _self.$router.push('/schedule');
                    _self.title = "日程";
                    _self.isShowLeftMenu = false;
                    break;
                case 4:
                    _self.$router.push('/netdisk');
                    _self.title = "网盘";
                    _self.isShowLeftMenu = false;
                    break;
                default:
                    break;
            }
        },
        // 显示左侧菜单
        showLeftMenu() {
            let _self = this;
            _self.isShowLeftMenu = true;
        }
    }
}
</script>

<style scoped>
.main-container {
    width: 100vw;
    height: 100vh;
}
</style>